export const en = {
  Aanhef: "Title",
  DeHeer: "Mr",
  Mevrouw: "Ms",
  Voorletters: "Initials",
  Achternaam: "Surname",
  Geboortenaam: "Maiden name (if married)",
  KenmerkCAK: "CAK reference",
  KenmerkCAKInfoTxt: "Your CAK ID number, code or reference number from the letter, your case number.",
  Straat: "Street",
  Huisnummer: "House number",
  Toevoeging: "Suffix",
  Postcode: "Postcode",
  Woonplaats: "Town/city",
  Land: "Country",
  Telefoonnummer: "Telephone number",
  EmailAdres: "Email address",
  EmailAdresInfoTxt: "We use this e-mail address if we want to contact you about your message.",
  Onderwerp: "Subject",
  OmschrijvingKlacht: "Description of complaint",
  HeeftUNogAanvullendeOpmerkingen: "Do you have any additional comments?",
  BedanktBericht: "Thank you for your message. Your message has reference number: {{klantContactId}}.",
  bijlage: "attachment",
  bijlagen: "attachments",
  Bijlagen: "Attachment(s)",
  Bijlage: "Attachment",
  BijlageToevoegen: "Add attachment",
  BijlageInfoTextMax1Attachment: "Max 1 attachment, max 5 MB per attachment.",
  BijlageInfoTextMax5Attachments: "Max 5 attachments, max 5 MB per attachment.",
  MeldingNoteerNummerVoorVerzending:
    "Make a note of the number that appears after sending. Please mention this number when you contact us with a question. This way we can help you better.",
  MeldingNoteerNummerNaVerzending:
    "Make a note of the number above. Please mention this number when you contact us with a question. This way we can help you faster.",
  KlachtenFormulierZvw: "Complaint form Zvw",
  OplossingKlacht: "What do you think should be the solution to your complaint?",
  NaarOnzeHomepage: "Go to our homepage",
  IsRequiredValidationFactoryValidationText: "The field '{{label}}' was not filled in.",
  HasMaxLengthValidationFactoryValidationText:
    "You have not filled in the field '{{label}}' correctly, you may enter a maximum of {{maxLength}} characters.",
  IsPostcodeValidationFactoryValidationText:
    "You have not filled in the '{{label}}' field correctly, for example: 1234 AB (replaced by your own postal code).",
  FileMaxSizeValidationText:
    "You have uploaded more than the maximum allowed file size in the input field '{{label}}', attachments may be a maximum of 5MB.",
  FileMaxSizeValidationTextAlternative:
    "'{{label}}' is larger than the maximum allowed file size, attachments can be a maximum of 5MB.",
  FileMaxNumberOfAttachmentsValidationText:
    "You have uploaded more than the permitted number of attachments in the field '{{label}}', you may upload a maximum of {{maxFiles}} {{bijlagen}}.",
  ErKunnenMaximaalAantalTekensIngevoerdWorden: "You can enter a maximum of {{aantal}} characters"
};
